import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ContentProvider } from "@/contexts/ContentContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BottomNav from "@/components/BottomNav";
import InstallPrompt from "@/components/InstallPrompt";
import ProtectedRoute from "@/components/ProtectedRoute";
import KycBanner from "@/components/KycBanner";
import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import ArtistProfile from "@/pages/ArtistProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ArtistOnboarding from "@/pages/ArtistOnboarding";
import Messages from "@/pages/Messages";
import PaymentReturn from "@/pages/PaymentReturn";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import MyTickets from "@/pages/MyTickets";
import ArtistEventsRoutes from "@/pages/ArtistEvents";
import { StaffScanner, ArtistScannerPage } from "@/pages/Scanner";
import AdminApp from "@/pages/Admin";
import Legal from "@/pages/Legal";
import { registerServiceWorker } from "@/lib/registerSW";

registerServiceWorker();

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col text-foreground">
            <Header />
            <KycBanner />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/explore" element={<Explore />} />
                <Route path="/artists/:id" element={<ArtistProfile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/artist/onboarding" element={<ProtectedRoute role="artist"><ArtistOnboarding /></ProtectedRoute>} />
                <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                <Route path="/messages/:conversationId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                <Route path="/payment/return" element={<ProtectedRoute><PaymentReturn /></ProtectedRoute>} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:id" element={<EventDetail />} />
                <Route path="/tickets" element={<ProtectedRoute><MyTickets /></ProtectedRoute>} />
                <Route path="/artist/events/*" element={<ProtectedRoute role="artist"><ArtistEventsRoutes /></ProtectedRoute>} />
                <Route path="/artist/scan" element={<ProtectedRoute role="artist"><ArtistScannerPage /></ProtectedRoute>} />
                <Route path="/scan/:code" element={<StaffScanner />} />
                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/admin/*" element={<ProtectedRoute role="admin"><AdminApp /></ProtectedRoute>} />
              </Routes>
            </main>
            <div className="hidden md:block"><Footer /></div>
            <BottomNav />
            <InstallPrompt />
          </div>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}
